import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Roter Stempel "100 % netzdienlich": fliegt ein, schlaegt auf und vibriert danach in Abstaenden.
// Startet erst, wenn er im sichtbaren Bereich ist. Bei "weniger Bewegung" steht er ruhig da.
const NetzdienlichStempel = ({ className = '', size = 'md', delay = 0.3 }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') { setShown(true); return undefined; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setShown(true); io.disconnect(); }
    }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`stamp-wrap ${className}`} style={{ '--stamp-delay': `${delay}s` }} data-testid="netzdienlich-stempel" role="img" aria-label={`100 % ${t('stamp.line2')}`}>
      <div className={`stamp stamp-${size} ${shown ? 'stamp-on' : 'stamp-off'}`}>
        <span className="stamp-top">100 %</span>
        <span className="stamp-bottom">{t('stamp.line2')}</span>
      </div>
    </div>
  );
};

export default NetzdienlichStempel;
